//@vendor
const get = require('lodash/object/get');
const isNumber = require('lodash/lang/isNumber');
const Moment = require('moment');
//@constants
const {
    DATE_FORMAT_API,
    DATE_FILTER_NONE,
    AMOUNT_LIMIT_FROM,
    AMOUNT_LIMIT_TO
} = require('constants/index');
//@actions
const actionTypes = require('../loansConstants/actionTypes');
//@helpers
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
// @utilities
const UrlHelper = require('utilities/urlHelper');

const getLoanMovementsRequest = loanId => ({
    type: actionTypes.FETCH_LOAN_MOVEMENTS_REQUEST,
    payload: {
        loanId
    }
});

const getLoanMovementsSuccess = (loanId, movements, loanType) => ({
    type: actionTypes.FETCH_LOAN_MOVEMENTS_SUCCESS,
    payload: {
        movements: get(movements, 'listaMovimientos.movimiento', []) || [],
        productCode: get(movements, 'codigoProducto', '') || '',
        nextPage: get(movements, '_links.nextPage.href', '') || '',
        loanId,
        loanType
    }
});

const getLoanMovementsFailure = (loanId, error, loanType) => ({
    type: actionTypes.FETCH_LOAN_MOVEMENTS_FAILURE,
    payload: {
        loanId,
        error,
        loanType
    }
});

const requestLoanMovements = loanId => (dispatch, getState) => {
    const loan = getState().loans.getIn(['byId', loanId]);
    const filter = getState().loansMovements.get('filters');
    const amountFrom = filter.getIn(['amount', 'from', 'amount']);
    const amountTo = filter.getIn(['amount', 'to', 'amount']);
    const loanType = loan.get('type'); // TODO: This don't exists in the reducer. check it

    const detailsRequestData = {
        query: {
            producto: loan.get('newProduct'),
            numeroContrato: loan.get('newContractNumber')
        }
    };

    if (filter.getIn(['date', 'selected']) !== DATE_FILTER_NONE) {
        detailsRequestData.query.fechaDesde = filter.getIn(['date', 'from']).format(DATE_FORMAT_API);
        detailsRequestData.query.fechaHasta = filter.getIn(['date', 'to']).format(DATE_FORMAT_API);
    } else {
        detailsRequestData.query.fechaDesde = Moment().subtract(5, 'years').format(DATE_FORMAT_API);
        detailsRequestData.query.fechaHasta = Moment().format(DATE_FORMAT_API);
    }

    const someFilledAmount = (amountFrom || amountTo);

    if (isNumber(amountFrom) || isNumber(amountTo)) {
        detailsRequestData.query.importeDesde = someFilledAmount && amountFrom || AMOUNT_LIMIT_FROM;
        detailsRequestData.query.importeHasta = someFilledAmount && amountTo || AMOUNT_LIMIT_TO;
    }

    dispatch(getLoanMovementsRequest(loanId));
    return APIGet({
        dispatch,
        endpoint: 'loansAndMortgagesMovements',
        url: apiURLBuilder.getURL('loansAndMortgagesMovements'),
        params: detailsRequestData
    })
        .then(response => dispatch(getLoanMovementsSuccess(loanId, response, loanType)))
        .catch(response => {
            if (!!response.error) {
                dispatch(getLoanMovementsFailure(loanId, response.error, loanType))
            }
            else throw response;
        })
};

const setLoanMovementsFilters = (filters, loanId) => (dispatch, getState) => {
    const currentFilters = getState().loansMovements.get('filters');
    const currentDate = currentFilters.get('date');
    const currentAmount = currentFilters.get('amount');
    const amountTo = filters.amount.to.amount;
    const amountFrom = filters.amount.from.amount;

    //check if new date is different from the current one.
    const newDateToHasChanged = !!currentDate.get('to') && !currentDate.get('to').isSame(filters.date.to, 'day');
    const newDateFromHasChanged = !!currentDate.get('from') && !currentDate.get('from').isSame(filters.date.from, 'day');

    //checks if new amoutns are setted and are different from the current ones.
    const newAmountToHasChanged = currentAmount.getIn(['to', 'amount']) !== amountTo;
    const newAmountFromHasChanged = currentAmount.getIn(['from', 'amount']) !== amountFrom;

    const amountsAreNull = amountFrom === null && amountTo === null;
    const someAmountsAreNull = amountFrom === null || amountTo === null;
    const someAmountsAreNumbers = isNumber(amountTo) || isNumber(amountFrom);
    const amountsAreNumbers = isNumber(amountTo) && isNumber(amountFrom);

    const isAmountValid = (amountsAreNumbers && amountFrom <= amountTo) || amountsAreNull || (someAmountsAreNull && someAmountsAreNumbers);

    if ((newDateToHasChanged || newDateFromHasChanged || newAmountToHasChanged || newAmountFromHasChanged) && isAmountValid) {
        dispatch({
            type: actionTypes.SET_LOAN_MOVEMENTS_FILTERS,
            payload: {
                filters
            }
        });
        dispatch(requestLoanMovements(loanId));
    }
};

const resetLoanMovementsFilter = (filter) => (dispatch) => {
    dispatch({
        type: actionTypes.RESET_LOAN_MOVEMENTS_FILTER,
        payload: {
            filter
        }
    });
};

const clearLoanMovementsFilters = loanId => (dispatch) => {
    dispatch({ type: actionTypes.CLEAR_LOAN_MOVEMENTS_FILTERS });
    dispatch(requestLoanMovements(loanId));
};

const nextPageRequest = () => ({
    type: actionTypes.LOAN_MOVEMENTS_FETCH_NEXT_PAGE
});

const nextPageSuccess = (response, loanId) => {
    return {
        type: actionTypes.LOAN_MOVEMENTS_FETCH_NEXT_PAGE_SUCCESS,
        payload: {
            loanId,
            nextPage: get(response, '_links.nextPage.href', ''),
            movements: get(response, 'listaMovimientos.movimiento', []) || [],
            productCode: get(response, 'codigoProducto', '')
        }
    };
};

const nextPageFailure = error => {
    return {
        type: actionTypes.LOAN_MOVEMENTS_FETCH_NEXT_PAGE_FAILURE,
        payload: {
            error
        }
    };
};

const requestNextPage = loanId => (dispatch, getState) => {
    const nextPageURL = getState().loansMovements.get('nextPage');
    const urlParams = UrlHelper.getQueryParams(nextPageURL.split('?')[1]);

    dispatch(nextPageRequest());
    return APIGet({
        dispatch,
        endpoint: 'loansAndMortgagesMovements',
        params: {
            query: urlParams
        }
    })
        .then(response => dispatch(nextPageSuccess(response, loanId)))
        .catch(response => {
            if (!!response.error) {
                dispatch(nextPageFailure(response.error));
            } else {
                throw response;
            }
        })
};

module.exports = {
    requestLoanMovements,
    setLoanMovementsFilters,
    clearLoanMovementsFilters,
    requestNextPage,
    resetLoanMovementsFilter
};
